import { type RefObject, useEffect, useState } from "react";

export function useSize(ref: RefObject<HTMLDivElement>) {
	/** State */
	const [size, setSize] = useState({ width: 0, height: 0 });

	/** Effects */
	useEffect(() => {
		if (ref.current) {
			const updateSize = () => {
				if (ref.current) {
					setSize({
						width: ref.current.offsetWidth,
						height: ref.current.offsetHeight,
					});
				}
			};

			updateSize();
			window.addEventListener("resize", updateSize);

			return () => {
				window.removeEventListener("resize", updateSize);
			};
		}
	}, [ref]);

	return size;
}
